import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { toFilter } from 'utils/widgetUtil'
import AnalysisFilter from 'types/analysisFilter'
import { InsightContentSettingType } from 'components/insightContent/types'
import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'

import { TagsWidgetsType, ExtendedInsightData } from '../../types'

export const getLabelByViewOption = (
  selectedInsights?: ExtendedInsightData[],
  viewOption?: InsightViewOptionStrings
) => {
  switch (viewOption) {
    case InsightViewOption.DOC_HIERARCHY: {
      const names = selectedInsights?.[0]?.searchName?.split('+') || []
      return names.length > 1 ? `${names?.length} Selected Items` : names[0]
    }
    case InsightViewOption.TAGS:
    default: {
      return selectedInsights?.[0]?.searchName
    }
  }
}

export const convertToInsightContentSetting = (
  widgetSetting: TagsWidgetsType,
  strategy: SearchFilterComposingStrategy,
  selection?: Array<ExtendedInsightData>
) => {
  const { viewOption } = widgetSetting

  const insightContentSetting = {
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    drillDownTypes: [''],
    drillDownFilter: {} as AnalysisFilter,
    topicInfos: widgetSetting.topicInfos!,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic.topicId!,
    insights: selection || null
  } as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  const insights = selection || null

  if (insights && insights.length > 0) {
    insightContentSetting.selectionName = getLabelByViewOption(insights, viewOption)

    insightContentSetting.selectionFilter = composeDetailSearchFilter(
      strategy,
      widgetSetting,
      insights
    )
  }
  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: TagsWidgetsType,
  strategy: WidgetSettingComposingStrategy,
  selection?: { insights?: Array<ExtendedInsightData> }
) => {
  if (!widgetSetting || typeof widgetSetting !== 'object') {
    return {}
  }

  if (!selection) {
    return {}
  }

  const { insights } = selection

  return composeDrillDownWidgetSetting(strategy, widgetSetting, insights || [])
}
